// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1Pxsq","load2":"Spinner_load2__3QcMM"};